import { Box, Divider, Grid, IconButton, InputAdornment, MenuItem, Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import useRiderReportController from "./controller"
import { SELECT_BACKGROUND_COLOR, TABLE_HEADER_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors"
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated"
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from "react-i18next";
import { DriverFinancialModel, DriverFinancialReportModel } from "../../models/driverFinancial";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import { convertDateStringToNormalString } from "../../utils/convertDateFormat";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RiderReportDetail from "./detail";
import TableSearchNotFound from "../../components/tableSearchNotFound";
import ButtonExportCsv from "../../components/ButtonExportCsv";
import { RIDER_REPORT_HEADER } from "./csvHeader/csvHeader";


const RiderReportView = () => {
    const controller = useRiderReportController()
    const { t } = useTranslation('global')
    const TableHeaders: string[] = [t("allReport_page.No"), t("allReport_page.Driver"), t("allReport_page.Position"), t("allReport_page.Total number of rounds"), t("allReport_page.Order amount"), t("allReport_page.District Rider Got"), t("allReport_page.Driver amount"), t("allReport_page.Total amount"), ""]

    return (
        <Box>
            {
                controller.loadingData ? <>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingAnimatedIcon />
                    </Box>
                </> :
                    <>
                        {
                            controller.openForm ? <RiderReportDetail onClose={controller.handleCloseForm} selectedData={controller.selectedData} /> : <Box>
                                <Box mb={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                        <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">{t("allReport_page.Rider Report")}</Typography>
                                        <TextField
                                            size="small"
                                            value={controller.searchValue}
                                            onChange={controller.handleSearch}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                )
                                            }}
                                            placeholder={`${t('allReport_page.Search By Rider name')}`} />
                                        {/* <TextField type="date" fullWidth
                                            value={controller.date}
                                            onChange={controller.handleChangeDate}
                                            sx={{
                                                maxWidth: 150, "& .MuiOutlinedInput-root": {
                                                    "& > fieldset": {
                                                        border: "none"
                                                    }
                                                }
                                            }} size="small" label={t("driverFinancial_page.Date")} InputProps={{
                                                disableUnderline: true,
                                                style: {
                                                    backgroundColor: SELECT_BACKGROUND_COLOR,
                                                    borderRadius: '8px'
                                                }
                                            }} InputLabelProps={{ shrink: true }} /> */}
                                    </Box>
                                </Box>
                                <Box mb={1}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Box sx={{ background: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between', boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);' }}>
                                                <Box>
                                                    <Typography color="#005249" sx={{ mb: 1 }}>{t("allReport_page.Total amount")}</Typography>
                                                    <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.moneyRider)} {t("allReport_page.kip")}</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Box sx={{ background: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between', boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);' }}>
                                                <Box>
                                                    <Typography color="#005249" sx={{ mb: 1 }}>{t("allReport_page.Total amount rider got")}</Typography>
                                                    <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.TotalMoneyRiderGot)} {t("allReport_page.kip")}</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        {/* <Grid item xs={12} sm={6} md={4}>
                                            <Box sx={{ background: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between', boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);' }}>
                                                <Box>
                                                    <Typography color="#005249" sx={{ mb: 1 }}>{t("allReport_page.Total amount return order")}</Typography>
                                                    <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.moneyRider)} {t("allReport_page.kip")}</Typography>
                                                </Box>
                                            </Box>
                                        </Grid> */}
                                    </Grid>
                                </Box>
                                <Box mb={1} mt={3} sx={{ display: 'flex', justifyContent: 'right' }}>
                                    <ButtonExportCsv
                                        loading={false}
                                        onClick={() => {
                                            if (controller.buttonExportCsv.current) {
                                                controller.buttonExportCsv.current.link.click();
                                            }
                                        }}
                                        buttonRef={controller.buttonExportCsv}
                                        title='Export csv'
                                        data={controller.getExportCsvData}
                                        filename="Rider Report"
                                        headers={RIDER_REPORT_HEADER}
                                    />
                                </Box>
                                <Box>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                                                <TableRow>
                                                    {
                                                        TableHeaders.map((item, index) => <TableCell key={index} sx={{ borderBottom: "none" }}>{item}</TableCell>)
                                                    }
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    controller.rows.map((row: DriverFinancialReportModel, index: number) => {

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.page - 1))}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {row?.rider?.username}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {row?.rider?.type}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {row?.totalRound}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {numberFormat(row?.orderAmount)}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {row?.totalDistanceRiderGot.toFixed(2)}
                                                                </TableCell>

                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {numberFormat(row?.rider?.totalMoney)} {t("Kip")}
                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    {numberFormat(row?.total)} {t("Kip")}
                                                                </TableCell>

                                                                <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                    <IconButton
                                                                        size="large"
                                                                        color="inherit"
                                                                        onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}
                                                                    >
                                                                        <MoreHorizIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                            {controller.isSearchNotFound && (
                                                <TableSearchNotFound
                                                    searchValue={controller.searchValue}
                                                    colSpan={TableHeaders.length}
                                                />
                                            )}
                                        </Table>
                                    </TableContainer>
                                    <Divider />
                                    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                                        <Pagination color="primary" page={controller.page} onChange={controller.handleChangePage} count={controller.countPagination} />
                                    </Box>
                                </Box>
                                <Popover
                                    open={Boolean(controller.openMenu)}
                                    anchorEl={controller.openMenu}
                                    onClose={controller.handleCloseMenu}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    PaperProps={{
                                        sx: {
                                            p: 1,
                                            width: 140,
                                            '& .MuiMenuItem-root': {
                                                px: 1,
                                                typography: 'body2',
                                                borderRadius: 0.75,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem onClick={controller.handleOpenForm}>
                                        &nbsp;&nbsp;
                                        {t('See Detail')}
                                    </MenuItem>
                                </Popover>
                            </Box>
                        }

                    </>
            }

        </Box>
    )
}
export default RiderReportView